var React = require('react');

function ArrowLeftWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,361.000000) scale(0.100000,-0.100000)","fill":"#ffffff","stroke":"none"},React.createElement("path",{"d":"M2392 3523 c-31 -6 -94 -66 -682 -648 -273 -269 -598 -589 -723 -710 -230 -222 -267 -268 -267 -331 1 -79 -7 -71 1145 -1200 379 -372 499 -484 528 -493 71 -24 157 9 197 74 26 41 29 134 7 168 -17 27 -648 653 -1114 1107 -183 177 -334 328 -336 334 -2 5 206 217 462 470 961 949 988 977 1001 1024 33 127 -78 231 -218 205z","fill":"#ffffff"})));
}

ArrowLeftWhite.defaultProps = {"version":"1.0","viewBox":"0 0 360.000000 361.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = ArrowLeftWhite;

ArrowLeftWhite.default = ArrowLeftWhite;
